export default {
    POST_BY_CALL: 11,    //Change it when MyWortPage.LATEST_TEASERS_NUMBER is changed !!!
    GEOLOCATION_DISTANCES: [0, 5, 10, 15],
    // Synchronize with backend
    CONTENT_FILTER: {
        POST: "post",
        EVENT: "event",
        POST_OR_EVENT: "post-event"
    },
    SURROUNDING_FILTER: {
        LOCALITY: "l",
        MUNICIPALITY: "m",
        AROUND: "a"
    },
    SEARCH_COMING_FROM: {
        GROUP_PAGE: "group",
        LOCALITY_PAGE: "locality",
        EVENT_MODULE: "event"
    },
    USER_MODULE_POSTS_LIMIT: 5
};



// WEBPACK FOOTER //
// ./js/mywort/frontend/configurations/Constants.js